/**
 * <ParentRequestsSection> — « Demandes en cours » sur l'accueil parent (template), juste après la prochaine
 * séance : ce que la famille a demandé et attend, une ligne par demande, dite de haut ; le détail s'ouvre au
 * geste. Plusieurs demandes peuvent courir à la fois : elles tiennent dans UNE carte à séparateurs.
 *
 * Comme « À faire », le bloc n'existe que s'il a quelque chose : sans demande, ni titre ni carte.
 */
import React from "react"

import { CardList } from "../../molecules/CardList"
import { List } from "../../molecules/List"
import { ParentRequestRow } from "../../molecules/ParentRequestRow"
import { type UIParentRequest } from "../../../ports/primary/ui/types"

export type ParentRequestsSectionProps = {
    requests: UIParentRequest[]
    onOpenRequest?: (request: UIParentRequest) => void
    testID?: string
}

export function ParentRequestsSection(props: ParentRequestsSectionProps) {
    const { requests, onOpenRequest, testID } = props
    if (requests.length === 0) return null

    return (
        <List title="Demandes en cours" testID={testID}>
            <CardList>
                {requests.map((request) => (
                    <ParentRequestRow key={request.id} request={request} onPress={onOpenRequest} />
                ))}
            </CardList>
        </List>
    )
}
